import { render, staticRenderFns } from "./katex.vue?vue&type=template&id=5d6e1b00&scoped=true&"
import script from "./katex.vue?vue&type=script&lang=js&"
export * from "./katex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6e1b00",
  null
  
)

export default component.exports